import { useState } from "react";
import "../challenge-joining-frames.css";
import Logo from "../../../../../ui/atoms/logo/Logo";
import BackgroundPaths from "../../../../../ui/molecules/background-paths/BackgroundPaths";
import InputText from "../../../../../ui/atoms/inputs/input-text/InputText";
import Button from "../../../../../ui/atoms/buttons/Button";
import Loading from "../../../../../ui/atoms/loading/Loading";
import { GiTeamIdea } from "react-icons/gi";
import { FaPersonRays } from "react-icons/fa6";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import players_data from "../../../../../core/helpers/players_data.json";
import { wait } from "../../../../../core/utils/helpers";
import { onUpdatePlayerNickname } from "../../../services/challenge";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../../../../app/providers/context-provider/useAxiosPrivate";

const dates = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

const JoiningNickNameFrame = () => {
  const axiosPrivate = useAxiosPrivate();

  const [isSending, setIsSending] = useState(false);
  const [playerNickName, setPlayerNickName] = useState("");

  const navigate = useNavigate();

  const initConnectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser,
  );
  const _sys_role = initConnectedUser?.sys_role;

  const userInformations = useSelector(
    (state) => state.setInitConf.userInformations,
  );
  // 

  const _firstname = userInformations?.firstname;
  const _lastname = userInformations?.lastname;

  const currentAssessment = useSelector(
    (state) => state?.challengeState?.currentAssessment,
  );
  const _request_id = currentAssessment?.request_id;
  const _challenge_type = currentAssessment?.challenge_type;
  const _teams_breakdown = currentAssessment?.teams_breakdown

  const onHandleRandomNickname = () => {
    // Generate a random number between 0 (inclusive) and 1 (exclusive)
    const randomIndex = Math.floor(Math.random() * players_data.length);
    // Use the random index to retrieve the element
    const randomNickname = players_data[randomIndex];
    setPlayerNickName(randomNickname);
  };

  const onHandleNextStep = async () => {
    setIsSending(true);
    await wait(500);
    //
    const local_data = {
      request_id: _request_id,
      player_name_joined: playerNickName,
      request_dates: dates,
    };

    onUpdatePlayerNickname(axiosPrivate, local_data)
      .then((response) => {
        const _data = response?.data;
        //
        setIsSending(false);
        //
        if (_data?.status) {
          if (_challenge_type === "classic") {
            const _to = `/${_sys_role}/challenge/joining/waiting/room`;
            navigate(_to, { replace: true });
          } else {
            if (_teams_breakdown === "automatic") {
              const _to = `/${_sys_role}/challenge/joining/waiting/room`;
              navigate(_to, { replace: true });
            }
            if (_teams_breakdown === "self-compose") {
              const _to = `/${_sys_role}/challenge/joining/team/compose`;
              navigate(_to, { replace: true });
            }
            if (_teams_breakdown === "self-choice") {
              const _to = `/${_sys_role}/challenge/joining/team/choice`;
              navigate(_to, { replace: true });
            }
          }
        } else {
          Swal.fire({
            icon: "warning",
            title: "Request Joining Challenge",
            text:
              _data?.message ||
              "An error occurred in the server. Please try again.",
          });
        }
      })
      .catch((error) => {
        setIsSending(false);
        if (!error?.response) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No server response",
          });
        } else {
          Swal.fire({
            icon: "warning",
            title: "Warning",
            text: error.response.data?.message || "An error occurred",
          });
        }
      });
  };

  return (
    <div className="joining-frame">
      <div className="j-f-inner">
        <BackgroundPaths />
      </div>
      <div className="j-f-outer">
        <div className="j-f-outer-head">
          <Logo to={null} width={"200px"} />
          <h1>Pamoja 4 Machine Intelligence University</h1>
          <div className="w-fit-content d-flex justify-center align-center pt-md pb-md">
            {_challenge_type === "team" ? (
              <>
                <GiTeamIdea className="icon" />
                <span>Team Mode</span>
              </>
            ) : (
              <>
                <FaPersonRays className="icon" />
                <span>Classic Mode</span>
              </>
            )}
          </div>
          <p>Setup Your Nickname.!</p>
        </div>
        <div className="j-f-outer-wrapper setup-nickname">
          <div className="w-full p-lg">
            <div className="w-full p-md">
              <InputText
                name="challenge_code"
                title="Type your Nickname Here..."
                value={playerNickName}
                onChange={(e) => setPlayerNickName(e.target.value)}
              />
            </div>
            {isSending ? (
              <Loading type={"type-1"} />
            ) : (
              <div className="fade-in w-full d-flex justify-center gap-md">
                <Button
                  type={"button"}
                  preferedStyle={"default"}
                  title={"Keep System Names"}
                  action={() => setPlayerNickName(`${_firstname} ${_lastname}`)}
                />
                <Button
                  type={"button"}
                  preferedStyle={"default"}
                  title={"Get random names"}
                  action={() => onHandleRandomNickname()}
                />
                {playerNickName.length > 0 && playerNickName.length < 16 && (
                  <Button
                    type={"button"}
                    preferedStyle={"normal"}
                    title={"Next!"}
                    action={() => onHandleNextStep()}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default JoiningNickNameFrame;
